var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"htmlPageViewer"}},[(!_vm.isHasData)?_c('NOT_DATA',{attrs:{"className":"relativePtb30"}}):_c('div',{staticClass:"htmlPage_container"},[_c('iframe',{ref:"iframeRef",staticClass:"htmlPage_iframe",attrs:{"src":_vm.htmlSrc,"frameborder":"0"},on:{"load":_vm.handleIframeLoad}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }